import styled from "styled-components";
import { colors } from "../../../utils";
import {darken} from 'polished'

const Wrapper
	= styled.div`
		display: flex;
		align-items: center;
		justify-content: center;
		gap: calc(4px + .2vw);
		padding: calc(4px + .4vw) calc(8px + .8vw);
		border-radius: 8px;

		&.warning {
			background-color: ${colors.empty.background};
			border: 1px solid ${colors.empty.border};
		}

		&.info {
			background-color: ${darken(.3, colors.primary)};
			border: 1px solid ${colors.primary};
		}

		img {
			width: calc(15px + 1vw);
		}

		.text {
			font-size: 110%;
		}
	`

export default Wrapper
